import { render } from "./EditMobilePhone.vue?vue&type=template&id=23a46bd7"
import script from "./EditMobilePhone.vue?vue&type=script&lang=js"
export * from "./EditMobilePhone.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__